import axios from "axios";

import { BACKEND_URL } from "../config";

// console.log("sss", process.env.PORTAL_BFF, "pp", process.env);

export const instance = axios.create({
  baseURL: BACKEND_URL,
});

// Quick Log impersonation no longer auto-swaps-back on 401. Per Levi
// 2026-05-27: the only way to leave an impersonation session is the manual
// "Swap back" button in ImpersonationBanner. Combined with the BFF removing
// the 1h hard cap on impersonation tokens, this means Quick Log sessions
// never end on their own — neither by idle-expiry on the BFF nor by a stray
// 401 on the frontend.
